import { api } from './api';

export interface Funcionario {
  id: number;
  codPessoa: number;
  codCargo: number;
  ativo: number;
  dataContratacao: string;
  dataRecisao: string | null;
  cnpj: string;
  codEndereco: number;
  cpf: string;
  dataNasc: string;
  email: string;
  nome: string;
  rg: string;
  telefone1: string;
  telefone2: string;
  bairro: string;
  cep: string;
  cidade: string;
  estado: string;
  logradouro: string;
  numero: string;
  nomeCargo?: string; // Para exibição na tabela
}

export interface FuncionarioCommand {
  id?: number;
  codPessoa: number;
  codCargo: number;
  ativo: number;
  dataContratacao: string;
  dataRecisao: string | null;
  cnpj: string;
  codEndereco: number;
  cpf: string;
  dataNasc: string;
  email: string;
  nome: string;
  rg: string;
  telefone1: string;
  telefone2: string;
  bairro: string;
  cep: string;
  cidade: string;
  estado: string;
  logradouro: string;
  numero: string;
}

export const funcionarioService = {
  // Buscar todos os funcionários
  getAll: async (): Promise<Funcionario[]> => {
    const response = await api.get<Funcionario[]>('/api/Funcionario/GetAll');
    return response.data;
  },

  // Buscar funcionário por ID
  getById: async (id: number): Promise<Funcionario> => {
    const response = await api.get<Funcionario>(`/api/Funcionario/GetById?id=${id}`);
    return response.data;
  },

  // Salvar funcionário (criar ou editar)
  save: async (funcionario: FuncionarioCommand): Promise<Funcionario> => {
    const response = await api.post<Funcionario>('/api/Funcionario/Salvar', funcionario);
    return response.data;
  },
};
